import { motion } from "framer-motion";
import { CheckCircle } from "lucide-react";
import styles from "./FollowUpManagement.module.css";

const FollowUpManagement = () => {
  return (
    <div className={styles.container}>
      {/* Hero Section */}
      <section className={styles.hero}>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9 }}
        >
          AI Sales Agent – Automate Follow-Up Management & Boost Sales
        </motion.h1>
        <p>
          Stop losing leads! <span className={styles.brand}>ToxBox AI</span>{" "}
          automates follow-ups, sends personalized reminders, and ensures no
          lead is left behind.
        </p>
        <motion.button whileHover={{ scale: 1.05 }} className={styles.cta}>
          Start Automating Follow-Ups
        </motion.button>
      </section>

      {/* Why Choose Section */}
      <section className={styles.section}>
        <h2>Why Choose ToxBox AI for Follow-Up Management?</h2>
        <p>
          ToxBox AI revolutionizes sales follow-up processes. Automate
          reminders, track leads, and prioritize engagement with AI-driven
          follow-up management.
        </p>
      </section>

      {/* How it Works */}
      <section className={styles.cards}>
        <h2>How Our AI Follow-Up System Works</h2>
        <div className={styles.cardGrid}>
          {[
            "Import leads from your CRM or spreadsheets",
            "AI prioritizes leads based on engagement and potential",
            "Automated follow-ups via email, SMS, chat, or calls",
            "Track responses and next steps",
            "Analyze performance through real-time analytics",
          ].map((item, i) => (
            <motion.div
              key={i}
              className={styles.card}
              whileHover={{ scale: 1.05 }}
            >
              <CheckCircle className={styles.icon} />
              <p>{item}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Features */}
      <section className={styles.cardsss}>
  <h2>Powerful Features</h2>
  <div className={styles.layout}>
    {/* Left side illustration */}
    {/* <div className={styles.illustration}>
      <img src="/your-image.png" alt="Illustration" />
    </div> */}

    {/* Right side cards */}
    <div className={styles.cardGriddd}>
      {[
        { text: "It Highlights Value, better the app appearance, better will be its impression on users.", icon: '1' },
        { text: "It Builds Connection with Users, users feel more connected with your brand when you pick elements as per their needs and comfort.", icon: '2' },
        { text: "It Simplifies Process, every activity becomes simple and streamlined when an icon/UI element guides the users.", icon: '3' },
        { text: "It Enhances App ROI, with increased customer satisfaction and engagement, UI design delivers higher ROI too.", icon: '4' },
      ].map((f, i) => (
        <motion.div key={i} className={styles.carddd} whileHover={{ scale: 1.05 }}>
          <span className={styles.iconnn}>{f.icon}</span>
          <p>{f.text}</p>
        </motion.div>
      ))}
    </div>
  </div>
</section>


      {/* CRM Integration */}
      <section className={styles.sectionDark}>
        <h2>Smart CRM Integration for Seamless Follow-Ups</h2>
        <p>
          ToxBox AI integrates with Salesforce, HubSpot, and Zoho. Automate
          follow-ups, sync contacts, and track engagement in real-time.
        </p>
        <motion.button whileHover={{ scale: 1.05 }} className={styles.ctaLight}>
          Integrate Your CRM Today
        </motion.button>
      </section>

      {/* FAQ */}
      <section className={styles.section}>
      <h2 className={styles.title}>Frequently Asked Questions</h2>
      <div className={styles.faqGrid}>
        <div className={styles.faqCard}>
          <h4 className={styles.question}>Can AI handle multi-channel follow-ups?</h4>
          <p className={styles.answer}>Yes, across email, SMS, chat, and calls.</p>
        </div>
        <div className={styles.faqCard}>
          <h4 className={styles.question}>Does AI prioritize leads automatically?</h4>
          <p className={styles.answer}>Yes, based on engagement and potential.</p>
        </div>
        <div className={styles.faqCard}>
          <h4 className={styles.question}>Is my data secure?</h4>
          <p className={styles.answer}>Absolutely, with encrypted storage.</p>
        </div>
        <div className={styles.faqCard}>
          <h4 className={styles.question}>Can it integrate with my existing CRM?</h4>
          <p className={styles.answer}>Yes, seamless integration supported.</p>
        </div>
      </div>
    </section>

      {/* Pricing */}
      {/* Pricing */}
<section className={styles.pricingSection}>
  <motion.div 
    className={styles.pricingCard}
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.6 }}
  >
    <h2>Flexible Pricing Plans</h2>
    <p>
      Choose a plan that fits your sales needs. Start free or upgrade for
      unlimited automated follow-ups, advanced analytics, and multi-channel
      messaging.
    </p>
    <motion.button 
      whileHover={{ scale: 1.1, boxShadow: "0 8px 25px rgba(150,105,229,0.4)" }}
      whileTap={{ scale: 0.95 }}
      className={styles.ctaLight}
    >
      View Pricing Plans
    </motion.button>
  </motion.div>
</section>

      {/* Final CTA */}
      <section className={styles.lower}>
        <h2>Start Automating Your Follow-Ups Today</h2>
        <p>
          Let <span className={styles.brand}>ToxBox AI</span> automate your lead
          engagement, improve conversions, and streamline your sales process.
        </p>
        <motion.button whileHover={{ scale: 1.05 }} className={styles.ctaLight}>
          Automate Follow-Ups Now
        </motion.button>
      </section>
    </div>
  );
};

export default FollowUpManagement;
